import { render, staticRenderFns } from "./QuickInvoiceItemList.vue?vue&type=template&id=52611b14"
import script from "./QuickInvoiceItemList.vue?vue&type=script&lang=js"
export * from "./QuickInvoiceItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52611b14')) {
      api.createRecord('52611b14', component.options)
    } else {
      api.reload('52611b14', component.options)
    }
    module.hot.accept("./QuickInvoiceItemList.vue?vue&type=template&id=52611b14", function () {
      api.rerender('52611b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quickinvoice/QuickInvoiceItemList.vue"
export default component.exports